import ajaxRequest from "../../utils/ajaxRequest";
import { API_PARAM } from "./apiParam";
import { API_QUERY } from "./apiQuery";

export default async function GetPlansData(data) {
    const { channelId, CBSAId, stateId } = data;
    let url = `${API_QUERY.formulary.plans}&ChannelId=${channelId}`;
    if (stateId !== undefined) {
        url += `&StateId=${stateId}`;
    } // Otherwise, CBSA is used
    else {
        url += `&CBSAId=${CBSAId}`;
    }
    const promiseObj = new Promise((resolve, reject) => {
        ajaxRequest({
            url: url,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${API_PARAM.token}`
            }
        })
            .then(res => {
                if (!res) {
                    resolve(false);
                    return;
                }
                const rs = JSON.parse(res);

                resolve(rs);
            })
            .catch(err => {
                reject(err);
            });
    });
    return promiseObj;
}
